/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RosewoodAiRouteImport } from './routes/rosewood-ai'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as PublicResourcesRouteImport } from './routes/_public/resources'
import { Route as PublicMediaRouteImport } from './routes/_public/media'
import { Route as PublicContactRouteImport } from './routes/_public/contact'
import { Route as PublicAboutRouteImport } from './routes/_public/about'
import { Route as PublicServicesIndexRouteImport } from './routes/_public/services/index'
import { Route as PublicBlogIndexRouteImport } from './routes/_public/blog/index'
import { Route as PublicServicesSlugRouteImport } from './routes/_public/services/$slug'
import { Route as PublicBlogSlugRouteImport } from './routes/_public/blog/$slug'

const RosewoodAiRoute = RosewoodAiRouteImport.update({
  id: '/rosewood-ai',
  path: '/rosewood-ai',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicIndexRoute = PublicIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicResourcesRoute = PublicResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => PublicRoute,
} as any)
const PublicMediaRoute = PublicMediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => PublicRoute,
} as any)
const PublicContactRoute = PublicContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => PublicRoute,
} as any)
const PublicAboutRoute = PublicAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => PublicRoute,
} as any)
const PublicServicesIndexRoute = PublicServicesIndexRouteImport.update({
  id: '/services/',
  path: '/services/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicBlogIndexRoute = PublicBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => PublicRoute,
} as any)
const PublicServicesSlugRoute = PublicServicesSlugRouteImport.update({
  id: '/services/$slug',
  path: '/services/$slug',
  getParentRoute: () => PublicRoute,
} as any)
const PublicBlogSlugRoute = PublicBlogSlugRouteImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => PublicRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof PublicIndexRoute
  '/rosewood-ai': typeof RosewoodAiRoute
  '/about': typeof PublicAboutRoute
  '/contact': typeof PublicContactRoute
  '/media': typeof PublicMediaRoute
  '/resources': typeof PublicResourcesRoute
  '/blog/$slug': typeof PublicBlogSlugRoute
  '/services/$slug': typeof PublicServicesSlugRoute
  '/blog/': typeof PublicBlogIndexRoute
  '/services/': typeof PublicServicesIndexRoute
}
export interface FileRoutesByTo {
  '/rosewood-ai': typeof RosewoodAiRoute
  '/about': typeof PublicAboutRoute
  '/contact': typeof PublicContactRoute
  '/media': typeof PublicMediaRoute
  '/resources': typeof PublicResourcesRoute
  '/': typeof PublicIndexRoute
  '/blog/$slug': typeof PublicBlogSlugRoute
  '/services/$slug': typeof PublicServicesSlugRoute
  '/blog': typeof PublicBlogIndexRoute
  '/services': typeof PublicServicesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_public': typeof PublicRouteWithChildren
  '/rosewood-ai': typeof RosewoodAiRoute
  '/_public/about': typeof PublicAboutRoute
  '/_public/contact': typeof PublicContactRoute
  '/_public/media': typeof PublicMediaRoute
  '/_public/resources': typeof PublicResourcesRoute
  '/_public/': typeof PublicIndexRoute
  '/_public/blog/$slug': typeof PublicBlogSlugRoute
  '/_public/services/$slug': typeof PublicServicesSlugRoute
  '/_public/blog/': typeof PublicBlogIndexRoute
  '/_public/services/': typeof PublicServicesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/rosewood-ai'
    | '/about'
    | '/contact'
    | '/media'
    | '/resources'
    | '/blog/$slug'
    | '/services/$slug'
    | '/blog/'
    | '/services/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/rosewood-ai'
    | '/about'
    | '/contact'
    | '/media'
    | '/resources'
    | '/'
    | '/blog/$slug'
    | '/services/$slug'
    | '/blog'
    | '/services'
  id:
    | '__root__'
    | '/_public'
    | '/rosewood-ai'
    | '/_public/about'
    | '/_public/contact'
    | '/_public/media'
    | '/_public/resources'
    | '/_public/'
    | '/_public/blog/$slug'
    | '/_public/services/$slug'
    | '/_public/blog/'
    | '/_public/services/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PublicRoute: typeof PublicRouteWithChildren
  RosewoodAiRoute: typeof RosewoodAiRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/rosewood-ai': {
      id: '/rosewood-ai'
      path: '/rosewood-ai'
      fullPath: '/rosewood-ai'
      preLoaderRoute: typeof RosewoodAiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/': {
      id: '/_public/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof PublicIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/resources': {
      id: '/_public/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof PublicResourcesRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/media': {
      id: '/_public/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof PublicMediaRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/contact': {
      id: '/_public/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof PublicContactRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/about': {
      id: '/_public/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof PublicAboutRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/services/': {
      id: '/_public/services/'
      path: '/services'
      fullPath: '/services/'
      preLoaderRoute: typeof PublicServicesIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/blog/': {
      id: '/_public/blog/'
      path: '/blog'
      fullPath: '/blog/'
      preLoaderRoute: typeof PublicBlogIndexRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/services/$slug': {
      id: '/_public/services/$slug'
      path: '/services/$slug'
      fullPath: '/services/$slug'
      preLoaderRoute: typeof PublicServicesSlugRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/blog/$slug': {
      id: '/_public/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof PublicBlogSlugRouteImport
      parentRoute: typeof PublicRoute
    }
  }
}

interface PublicRouteChildren {
  PublicAboutRoute: typeof PublicAboutRoute
  PublicContactRoute: typeof PublicContactRoute
  PublicMediaRoute: typeof PublicMediaRoute
  PublicResourcesRoute: typeof PublicResourcesRoute
  PublicIndexRoute: typeof PublicIndexRoute
  PublicBlogSlugRoute: typeof PublicBlogSlugRoute
  PublicServicesSlugRoute: typeof PublicServicesSlugRoute
  PublicBlogIndexRoute: typeof PublicBlogIndexRoute
  PublicServicesIndexRoute: typeof PublicServicesIndexRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicAboutRoute: PublicAboutRoute,
  PublicContactRoute: PublicContactRoute,
  PublicMediaRoute: PublicMediaRoute,
  PublicResourcesRoute: PublicResourcesRoute,
  PublicIndexRoute: PublicIndexRoute,
  PublicBlogSlugRoute: PublicBlogSlugRoute,
  PublicServicesSlugRoute: PublicServicesSlugRoute,
  PublicBlogIndexRoute: PublicBlogIndexRoute,
  PublicServicesIndexRoute: PublicServicesIndexRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PublicRoute: PublicRouteWithChildren,
  RosewoodAiRoute: RosewoodAiRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
